import { Color, File, Product } from '@app/models';
import { Action } from '@ngrx/store';

interface LoadByFollowOptions {
  deletedAt: boolean;
  type: 'minimal';
  condition: any;
  valueCondition: number;
}

export enum ProductActionTypes {
  Load = '[Product] Load',
  LoadSuccess = '[Product] Load Success',
  LoadFail = '[Product] Load Fail',

  LoadSingle = '[Product] Load single',
  LoadSingleSuccess = '[Product] Load single Success',
  LoadSingleFail = '[Product] Load single Fail',

  LoadByCountryDepartment = '[Product] Load by Country Department',
  LoadByCountryDepartmentSuccess = '[Product] Load by Country Department Success',
  LoadByCountryDepartmentFail = '[Product] Load by Country Department Fail',

  LoadProductsForFoodShowroom = '[Product] Load Products For Food Showroom',
  LoadProductsForFoodShowroomSuccess = '[Product] Load Products For Food Showroom Success',
  LoadProductsForFoodShowroomFail = '[Product] Load Products For Food Showroom Fail',

  CreateColor = '[API] Add Product Color',
  CreateColorSuccess = '[API] Add Product Color Success',
  CreateColorFail = '[API] Add Product Color Fail',
  LoadByFollow = '[Product] Load by follow',
  LoadByFollowSuccess = '[Product] Load by follow Success',
  LoadByFollowFail = '[Product] Load by follow Fail',
  AddOne = '[Product] Add one',
  AddMany = '[Product] Add many',
  UpdateOne = '[Product] Update one',
  OptimisticUpdateOne = '[Product] Optimistic update one',
  OptimisticUpdateOneFail = '[Product] Optimistic update one fail',
  OptimisticUpdateOneSuccess = '[Product] Optimistic product update',
  OptimisticUpdateMany = '[Product] Optimistic update Many',
  OptimisticUpdateManyFail = '[Product] Optimistic update Many fail',
  OptimisticUpdateManySuccess = '[Product] Optimistic product update Many',
  AddPicture = '[Product] Add picture',
  AddColor = '[Product] Add color',
  DestroyColor = '[API] Destroy product color',
  DestroyColorSuccess = '[API] Destroy product color success',
  DestroyColorFail = '[API] Destroy product color fail',
  RemoveColor = '[Product] Remove color',
  AddToFileCount = '[Product] Add to file count',
  RemoveFromFileCount = '[Product] Remove from file count',
  UpsertMany = '[Product] Upsert many',

  BulkUpdate = '[API] Bulk update products',
  BulkUpdateSuccess = '[API] Bulk update products success',
  BulkUpdateFail = '[API] Bulk update products fail',

  EmptyTrash = '[API] Empty trash',
  EmptyTrashSuccess = '[API] Empty trash success',
  EmptyTrashFail = '[API] Empty trash fail',

  RestoreTrash = '[API] Restore trash',
  RestoreTrashSuccess = '[API] Restore trash success',
  RestoreTrashFail = '[API] Restore trash fail',

  DestroySingle = '[API] Destroy single product',
  DestroySingleSuccess = '[API] Destroy single product success',
  DestroySingleFail = '[API] Destroy single product fail',

  Search = '[Product] search products by conditions',
  SearchSuccess = '[Product] search products success',
  SearchFail = '[Product] search products failed',
  SearchClear = '[Product] clear search',

  BulkDestroy = '[Product] Destroy bulk products',
  BulkDestroyFail = '[Product] Fail Destroy bulk products',
  BulkDestroySuccess = '[Product] Success destroy bulk products',

  Filter = '[Product] filter success',
  FilterClear = '[Product] clear filter',

  BulkAlive = '[Product] Alive bulk products',
  BulkAliveSuccess = '[Product] Success Alive bulk products',
  BulkAliveFail = '[Product] Fail Alive bulk products ',

  DeletePictures = '[Product] Delete image product',
  DeletePicturesSuccess = '[Product] Delete image product success',

  Clear = '[Product] clear current products on state',

  UpdateOneProductsForFoodShowroom = '[Product] Update on products for food showroom',
  UpdateOneProductsForFoodShowroomSuccess = '[Product] Update on products for food showroom success',
  UpdateOneProductsForFoodShowroomFail = '[Product] Update on products for food showroom fail',

  UpsertProductsLikesForFoodShowroom = '[Product] Upsert products likes for food showroom',
  UpsertProductsLikesForFoodShowroomSuccess = '[Product] Upsert products likes for food showroom success',
  UpsertProductsLikesForFoodShowroomFail = '[Product] Upsert products likes for food showroom fail',

  SendProductsLikesMailForFoodShowroom = '[Product] Send products likes mail for food showroom',
  SendProductsLikesMailForFoodShowroomSuccess = '[Product] Send products likes mail for food showroom success',
  SendProductsLikesMailForFoodShowroomFail = '[Product] Send products likes mail for food showroom fail',

  SendProductsLikesMailForFoodShowroomProcessPending = '[Product] Send products likes mail for food showroom process pending',
  SendProductsLikesMailForFoodShowroomProcessSuccess = '[Product] Send products likes mail for food showroom process success',
  SendProductsLikesMailForFoodShowroomProcessFail = '[Product] Send products likes mail for food showroom process fail',

  MailProductsLikesMailForFoodShowroomProcessPending = '[Product] Mail products likes mail for food showroom process pending',
  MailProductsLikesMailForFoodShowroomProcessSuccess = '[Product] Mail products likes mail for food showroom process success',
  MailProductsLikesMailForFoodShowroomProcessFail = '[Product] Mail products likes mail for food showroom process fail',

  GetTechnicalFileLink = '[Product] Get technical file link',
  GetTechnicalFileLinkFail = '[Product] Get technical file link fail',
  UploadTechnicalFile = '[Product] Upload Technical File',
  UploadTechnicalFileSuccess = '[Product] Upload Technical File success',
  UploadTechnicalFileFail ='[Product] Upload Technical File fail',
  DownloadTechnicalFile = '[Product] Download technical file',
  DownloadTechnicalFileSuccess = '[Product] Download technical file success',
  DownloadTechnicalFileFail = '[Product] Download technical file fail',
  DeleteTechnicalFile ='[Product] Delete technical file',
  DeleteTechnicalFileSuccess ='[Product] Delete technical file success',
  DeleteTechnicalFileFail ='[Product] Delete technical file fail',

  ProductsPurchaseSummary ='[Product] Products purchase summary',
  ProductsPurchaseSummarySuccess ='[Product] Products purchase summary success',
  ProductsPurchaseSummaryFail ='[Product] Products purchase summary fail',
  
  ProductsTroncalsByCountries ='[Product] products troncals by countries',
  ProductsTroncalsByCountriesSuccess ='[Product] products troncals by countries success',
  ProductsTroncalsByCountriesFail ='[Product] products troncals by countries fail',
}

export class MailProductsLikesMailForFoodShowroomProcessPending implements Action {
  readonly type = ProductActionTypes.MailProductsLikesMailForFoodShowroomProcessPending;
  constructor(public data?: any) {}
}

export class MailProductsLikesMailForFoodShowroomProcessSuccess implements Action {
  readonly type = ProductActionTypes.MailProductsLikesMailForFoodShowroomProcessSuccess;
  constructor(public data?: any) {}
}

export class MailProductsLikesMailForFoodShowroomProcessFail implements Action {
  readonly type = ProductActionTypes.MailProductsLikesMailForFoodShowroomProcessFail;
  constructor(public error?: any) {}
}

export class SendProductsLikesMailForFoodShowroomProcessPending implements Action {
  readonly type = ProductActionTypes.SendProductsLikesMailForFoodShowroomProcessPending;
  constructor(public data?: any) {}
}

export class SendProductsLikesMailForFoodShowroomProcessSuccess implements Action {
  readonly type = ProductActionTypes.SendProductsLikesMailForFoodShowroomProcessSuccess;
  constructor(public data?: any) {}
}

export class SendProductsLikesMailForFoodShowroomProcessFail implements Action {
  readonly type = ProductActionTypes.SendProductsLikesMailForFoodShowroomProcessFail;
  constructor(public error?: any) {}
}

export class SendProductsLikesMailForFoodShowroom implements Action {
  readonly type = ProductActionTypes.SendProductsLikesMailForFoodShowroom;
  constructor(public data?: any) {}
}

export class SendProductsLikesMailForFoodShowroomSuccess implements Action {
  readonly type = ProductActionTypes.SendProductsLikesMailForFoodShowroomSuccess;
  constructor(public data?: any) {}
}

export class SendProductsLikesMailForFoodShowroomFail implements Action {
  readonly type = ProductActionTypes.SendProductsLikesMailForFoodShowroomFail;
  constructor(public error?: any) {}
}

export class UpsertProductsLikesForFoodShowroom implements Action {
  readonly type = ProductActionTypes.UpsertProductsLikesForFoodShowroom;
  constructor(public data: any) {}
}

export class UpsertProductsLikesForFoodShowroomSuccess implements Action {
  readonly type = ProductActionTypes.UpsertProductsLikesForFoodShowroomSuccess;
  constructor(public data?: any) {}
}

export class UpsertProductsLikesForFoodShowroomFail implements Action {
  readonly type = ProductActionTypes.UpsertProductsLikesForFoodShowroomFail;
  constructor(public error?: any) {}
}

export class UpdateOneProductsForFoodShowroom implements Action {
  readonly type = ProductActionTypes.UpdateOneProductsForFoodShowroom;
  constructor(public productId: number, public claims: any) {}
}

export class UpdateOneProductsForFoodShowroomSuccess implements Action {
  readonly type = ProductActionTypes.UpdateOneProductsForFoodShowroomSuccess;
  constructor(public data?: any) {}
}

export class UpdateOneProductsForFoodShowroomFail implements Action {
  readonly type = ProductActionTypes.UpdateOneProductsForFoodShowroomFail;
  constructor(public error?: any) {}
}

export class Load implements Action {
  readonly type = ProductActionTypes.Load;
  constructor() {}
}

export class LoadSuccess implements Action {
  readonly type = ProductActionTypes.LoadSuccess;
  constructor(public products: Product[]) {}
}

export class LoadFail implements Action {
  readonly type = ProductActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class LoadSingle implements Action {
  readonly type = ProductActionTypes.LoadSingle;
  constructor(public id: number) {}
}

export class LoadSingleSuccess implements Action {
  readonly type = ProductActionTypes.LoadSingleSuccess;
  constructor(public product: Product) {}
}

export class LoadSingleFail implements Action {
  readonly type = ProductActionTypes.LoadSingleFail;
  constructor(public error: any) {}
}

export class BulkUpdate implements Action {
  readonly type = ProductActionTypes.BulkUpdate;
  constructor(public data: any) {}
}

export class BulkUpdateFail implements Action {
  readonly type = ProductActionTypes.BulkUpdateFail;
  constructor(public error: any) {}
}

export class BulkUpdateSuccess implements Action {
  readonly type = ProductActionTypes.BulkUpdateSuccess;
  constructor(public data: any) {}
}

// TODO: fix thissss
export class CreateColor implements Action {
  readonly type = ProductActionTypes.CreateColor;
  constructor(public productId: number, public colorId: number) {}
}

export class CreateColorSuccess implements Action {
  readonly type = ProductActionTypes.CreateColorSuccess;
  constructor(public res: any) {}
}

export class CreateColorFail implements Action {
  readonly type = ProductActionTypes.CreateColorFail;
  constructor(public error: any) {}
}

export class DeletePictures implements Action {
  readonly type = ProductActionTypes.DeletePictures;
  constructor(public file: File, public productId: number) {}
}

export class DeletePicturesSuccess implements Action {
  readonly type = ProductActionTypes.DeletePicturesSuccess;
  constructor(public productId: any) {}
}

// ends TODO

export class LoadByFollow implements Action {
  readonly type = ProductActionTypes.LoadByFollow;
  constructor(public id: number, public opts?: Partial<LoadByFollowOptions>) {}
}

export class LoadByFollowSuccess implements Action {
  readonly type = ProductActionTypes.LoadByFollowSuccess;
  constructor(public products: Product[], public followId: number) {}
}

export class LoadByFollowFail implements Action {
  readonly type = ProductActionTypes.LoadByFollowFail;
  constructor(public error: any) {}
}

export class LoadByCountryDepartment implements Action {
  readonly type = ProductActionTypes.LoadByCountryDepartment;
  constructor(
    public FollowId: number,
    public countryDepartmentId: any,
    public CountryId?: number,
    public businessUnit?: any,
    public typeHierarchy?: any,
    public DestinationCenterId?: any
  ) {}
}

export class LoadByCountryDepartmentSuccess implements Action {
  readonly type = ProductActionTypes.LoadByCountryDepartmentSuccess;
  constructor(public products: Product[]) {}
}

export class LoadByCountryDepartmentFail implements Action {
  readonly type = ProductActionTypes.LoadByCountryDepartmentFail;
  constructor(public error: any) {}
}

export class LoadProductsForFoodShowroom implements Action {
  readonly type = ProductActionTypes.LoadProductsForFoodShowroom;
  constructor(
    public followId: number,
  ) {}
}

export class LoadProductsForFoodShowroomSuccess implements Action {
  readonly type = ProductActionTypes.LoadProductsForFoodShowroomSuccess;
  constructor(public productsFood: any) {}
}

export class LoadProductsForFoodShowroomFail implements Action {
  readonly type = ProductActionTypes.LoadProductsForFoodShowroomFail;
  constructor(public error: any) {}
}



export class AddOne implements Action {
  readonly type = ProductActionTypes.AddOne;
  constructor(public product: Product) {}
}

export class AddMany implements Action {
  readonly type = ProductActionTypes.AddMany;
  constructor(public products: Product[]) {}
}

export class AddPicture implements Action {
  readonly type = ProductActionTypes.AddPicture;
  constructor(public file: File) {}
}

export class AddColor implements Action {
  readonly type = ProductActionTypes.AddColor;
  constructor(public ProductId: number, public color: Color) {}
}

// TODO: fix thissss
export class DestroyColor implements Action {
  readonly type = ProductActionTypes.DestroyColor;
  constructor(public ProductId: number, public ColorId: number) {}
}

export class DestroyColorSuccess implements Action {
  readonly type = ProductActionTypes.DestroyColorSuccess;
  constructor(public res: any) {}
}

export class DestroyColorFail implements Action {
  readonly type = ProductActionTypes.DestroyColorFail;
  constructor(public error: any) {}
}

export class RemoveColor implements Action {
  readonly type = ProductActionTypes.RemoveColor;
  constructor(public ProductId: number, public ColorId: any) {}
}
export class OptimisticUpdateOne implements Action {
  readonly type = ProductActionTypes.OptimisticUpdateOne;
  constructor (
    public ProductId: number,
    public state: any,
    public newState: any
  ) {}
}

export class OptimisticUpdateOneFail implements Action {
  readonly type = ProductActionTypes.OptimisticUpdateOneFail;
  constructor(public ProductId: number, public state: any, public error: any) {}
}

export class OptimisticUpdateOneSuccess implements Action {
  readonly type = ProductActionTypes.OptimisticUpdateOneSuccess;
  constructor(public ProductId: number, public state: any) {}
}

export class OptimisticUpdateMany implements Action {
  readonly type = ProductActionTypes.OptimisticUpdateMany;
  constructor(
    public ProductIds: number[],
    public state: any,
    public newState: any
  ) {}
}

export class OptimisticUpdateManyFail implements Action {
  readonly type = ProductActionTypes.OptimisticUpdateManyFail;
  constructor(
    public ProductIds: number[],
    public state: any,
    public error: any
  ) {}
}

export class OptimisticUpdateManySuccess implements Action {
  readonly type = ProductActionTypes.OptimisticUpdateManySuccess;
  constructor(public ProductIds: number[], public state: any) {}
}

export class UpdateOne implements Action {
  readonly type = ProductActionTypes.UpdateOne;
  constructor(public product: Product) {}
}

export class UpsertMany implements Action {
  readonly type = ProductActionTypes.UpsertMany;
  constructor(public products: Product[]) {}
}

export class AddToFileCount implements Action {
  readonly type = ProductActionTypes.AddToFileCount;
  constructor(public id: number) {}
}

export class RemoveFromFileCount implements Action {
  readonly type = ProductActionTypes.RemoveFromFileCount;
  constructor(public id: number) {}
}

export class BulkDestroy implements Action {
  readonly type = ProductActionTypes.BulkDestroy;
  constructor(public ProductIds: number[], public FollowId: number) {}
}

export class BulkDestroyFail implements Action {
  readonly type = ProductActionTypes.BulkDestroyFail;
  constructor(public error: any) {}
}

export class BulkDestroySuccess implements Action {
  readonly type = ProductActionTypes.BulkDestroySuccess;
  constructor(public ProductIds: number[], public data: any) {}
}

export class RestoreTrash implements Action {
  readonly type = ProductActionTypes.RestoreTrash;
  constructor(public data?: any) {}
}

export class RestoreTrashFail implements Action {
  readonly type = ProductActionTypes.RestoreTrashFail;
  constructor(public error: any) {}
}

export class RestoreTrashSuccess implements Action {
  readonly type = ProductActionTypes.RestoreTrashSuccess;
  constructor(public FollowId: number) {}
}

export class EmptyTrash implements Action {
  readonly type = ProductActionTypes.EmptyTrash;
  constructor(public FollowId: number) {}
}

export class EmptyTrashFail implements Action {
  readonly type = ProductActionTypes.EmptyTrashFail;
  constructor(public error: any) {}
}

export class EmptyTrashSuccess implements Action {
  readonly type = ProductActionTypes.EmptyTrashSuccess;
  constructor(public FollowId: number) {}
}

export class DestroySingle implements Action {
  readonly type = ProductActionTypes.DestroySingle;
  constructor(public ProductId: number) {}
}

export class DestroySingleFail implements Action {
  readonly type = ProductActionTypes.DestroySingleFail;
  constructor(public error: any) {}
}

export class DestroySingleSuccess implements Action {
  readonly type = ProductActionTypes.DestroySingleSuccess;
  constructor(public ProductId: number) {}
}

export class Search implements Action {
  readonly type = ProductActionTypes.Search;
  constructor(public conditions: any, public FollowId: number) {}
}

export class SearchSuccess implements Action {
  readonly type = ProductActionTypes.SearchSuccess;
  constructor(public ProductIds: number[]) {}
}

export class SearchFail implements Action {
  readonly type = ProductActionTypes.SearchFail;
  constructor(public error: any) {}
}

export class SearchClear implements Action {
  readonly type = ProductActionTypes.SearchClear;
  constructor() {}
}

export class Filter implements Action {
  readonly type = ProductActionTypes.Filter;
  constructor(public key: any) {}
}

export class FilterClear implements Action {
  readonly type = ProductActionTypes.FilterClear;
  constructor(public key: any) {}
}

export class BulkAlive implements Action {
  readonly type = ProductActionTypes.BulkAlive;
  constructor(public ProductId: number, public FollowId: number) {}
}

export class BulkAliveFail implements Action {
  readonly type = ProductActionTypes.BulkAliveFail;
  constructor(public error: any) {}
}

export class BulkAliveSuccess implements Action {
  readonly type = ProductActionTypes.BulkAliveSuccess;
  constructor(public ProductId: any, public data: any) {}
}

export class Clear implements Action {
  readonly type = ProductActionTypes.Clear;
  constructor() {}
}

export class GetTechnicalFileLink implements Action {
  readonly type = ProductActionTypes.GetTechnicalFileLink;
  constructor(
    public productId: any,
    public file: any,
    public fileableType: string,
    public followId: any
  ) {}
}

export class GetTechnicalFileLinkFail implements Action {
  readonly type = ProductActionTypes.GetTechnicalFileLinkFail;
  constructor(public error?: any) {}
}

export class UploadTechnicalFile implements Action {
  readonly type = ProductActionTypes.UploadTechnicalFile;
  constructor(
    public link: any,
    public file: any,
    public productId?: number
    ) {}
}

export class UploadTechnicalFileSuccess implements Action {
  readonly type = ProductActionTypes.UploadTechnicalFileSuccess;
  constructor(public data?: any) {}
}

export class UploadTechnicalFileFail implements Action {
  readonly type = ProductActionTypes.UploadTechnicalFileFail;
  constructor(public error?: any) {}
}

export class DownloadTechnicalFile implements Action {
  readonly type = ProductActionTypes.DownloadTechnicalFile;
  constructor(public productId?: any) {}
}

export class DownloadTechnicalFileSuccess implements Action {
  readonly type = ProductActionTypes.DownloadTechnicalFileSuccess;
  constructor(public data?: any) {}
}

export class DownloadTechnicalFileFail implements Action {
  readonly type = ProductActionTypes.DownloadTechnicalFileFail;
  constructor(public error?: any) {}
}

export class DeleteTechnicalFile implements Action {
  readonly type = ProductActionTypes.DeleteTechnicalFile;
  constructor(public productId: any, public followId: any) {}
}

export class DeleteTechnicalFileSuccess implements Action {
  readonly type = ProductActionTypes.DeleteTechnicalFileSuccess;
  constructor(public data?: any) {}
}

export class DeleteTechnicalFileFail implements Action {
  readonly type = ProductActionTypes.DeleteTechnicalFileFail;
  constructor(public error?: any) {}
}

export class ProductsPurchaseSummary implements Action {
  readonly type = ProductActionTypes.ProductsPurchaseSummary;
  constructor(public followId: any) {}
}

export class ProductsPurchaseSummarySuccess implements Action {
  readonly type = ProductActionTypes.ProductsPurchaseSummarySuccess;
  constructor(public data?: any) {}
}

export class ProductsPurchaseSummaryFail implements Action {
  readonly type = ProductActionTypes.ProductsPurchaseSummaryFail;
  constructor(public error?: any) {}
}

export class ProductsTroncalsByCountries implements Action {
  readonly type = ProductActionTypes.ProductsTroncalsByCountries;
  constructor(public followId: any) {}
}

export class ProductsTroncalsByCountriesSuccess implements Action {
  readonly type = ProductActionTypes.ProductsTroncalsByCountriesSuccess;
  constructor(public data?: any) {}
}

export class ProductsTroncalsByCountriesFail implements Action {
  readonly type = ProductActionTypes.ProductsTroncalsByCountriesFail;
  constructor(public error?: any) {}
}


export type ProductActionsUnion =
  | Load
  | LoadSuccess
  | LoadFail
  | LoadSingle
  | LoadSingleSuccess
  | LoadSingleFail
  | LoadByFollow
  | LoadByFollowSuccess
  | LoadByFollowFail
  | LoadByCountryDepartment
  | LoadByCountryDepartmentSuccess
  | LoadByCountryDepartmentFail
  | CreateColor
  | CreateColorSuccess
  | CreateColorFail
  | AddOne
  | AddMany
  | AddPicture
  | AddColor
  | RemoveColor
  | DestroyColor
  | DestroyColorSuccess
  | DestroyColorFail
  | UpdateOne
  | AddToFileCount
  | RemoveFromFileCount
  | UpsertMany
  | OptimisticUpdateOne
  | OptimisticUpdateOneSuccess
  | OptimisticUpdateOneFail
  | OptimisticUpdateMany
  | OptimisticUpdateManySuccess
  | OptimisticUpdateManyFail
  | BulkUpdate
  | BulkUpdateSuccess
  | BulkUpdateFail
  | EmptyTrash
  | EmptyTrashSuccess
  | EmptyTrashFail
  | RestoreTrash
  | RestoreTrashSuccess
  | RestoreTrashFail
  | DestroySingle
  | DestroySingleSuccess
  | DestroySingleFail
  | Search
  | SearchSuccess
  | SearchFail
  | SearchClear
  | BulkDestroy
  | BulkDestroyFail
  | BulkDestroySuccess
  | Filter
  | FilterClear
  | BulkAlive
  | BulkAliveSuccess
  | BulkAliveFail
  | Clear
  | DeletePictures
  | DeletePicturesSuccess
  | LoadProductsForFoodShowroom
  | LoadProductsForFoodShowroomSuccess
  | LoadProductsForFoodShowroomFail
  | UpdateOneProductsForFoodShowroom
  | UpdateOneProductsForFoodShowroomSuccess
  | UpdateOneProductsForFoodShowroomFail
  | UpsertProductsLikesForFoodShowroom
  | UpsertProductsLikesForFoodShowroomSuccess
  | UpsertProductsLikesForFoodShowroomFail
  | SendProductsLikesMailForFoodShowroom
  | SendProductsLikesMailForFoodShowroomSuccess
  | SendProductsLikesMailForFoodShowroomFail
  | SendProductsLikesMailForFoodShowroomProcessPending
  | SendProductsLikesMailForFoodShowroomProcessSuccess
  | SendProductsLikesMailForFoodShowroomProcessFail
  | MailProductsLikesMailForFoodShowroomProcessPending
  | MailProductsLikesMailForFoodShowroomProcessSuccess
  | MailProductsLikesMailForFoodShowroomProcessFail
  | GetTechnicalFileLink
  | GetTechnicalFileLinkFail
  | UploadTechnicalFile
  | UploadTechnicalFileSuccess
  | UploadTechnicalFileFail
  | DownloadTechnicalFile
  | DownloadTechnicalFileSuccess
  | DownloadTechnicalFileFail
  | DeleteTechnicalFile
  | DeleteTechnicalFileSuccess
  | DeleteTechnicalFileFail
  | ProductsPurchaseSummary
  | ProductsPurchaseSummarySuccess
  | ProductsPurchaseSummaryFail
  | ProductsTroncalsByCountries
  | ProductsTroncalsByCountriesSuccess
  | ProductsTroncalsByCountriesFail;
